/* NOTE: if you add anything new to this state please update the comment bellow */

/*
what data saved on this state ?
- hidden fields with their values
- verified code and uuid of otp field
  . uuid
  . code
- submit referer address (url address of the form. `submitter_referer_address`)
- submit_code // the slug of draft form (if form used partial submit)
*/

const generalData = (state = {}, action) => {
  switch (action.type) {
    case 'SET_GENERAL_SUBMIT_DATA':
      return { ...state, ...action.data }

    default:
      return state
  }
}

export default generalData
